import {useState, useEffect, } from 'react';
import logo from './logo.svg';
import packageJson from '../package.json';
// import './App.css';
import BaseLayout from './pages/layout/base';
import $ from 'jquery'
import { pdfjs } from 'react-pdf';


import { getToken, onMessageListener } from './firebaseInit';

import firebase from 'firebase/app';
import 'firebase/messaging';

import {isSafari, isMobileSafari} from 'react-device-detect'

window.jQuery = $
var jQuery = $
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function getOS(){
  const os = ['Windows', 'Linux', 'Mac'];
  return os.find(v=>navigator.appVersion.indexOf(v) >= 0)
}

function App() {
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({title: '', body: ''});
  const [isTokenFound, setTokenFound] = useState(false);

  if(getOS() !== 'Mac'){
    if(!isMobileSafari || !isSafari){
      if(firebase.messaging.isSupported()){
        firebase.messaging().requestPermission()

        onMessageListener().then(payload => {
          setShow(true);
          setNotification({title: payload.notification.title, body: payload.notification.body})
        }).catch(err => console.log('failed: ', err));
      }
    }
  }

	useEffect(() => {
		// reload_new_version()
	}, [])



  return (
    <div className="app">
      <BaseLayout />
    </div>
  );
}

export default App;
